export default __webpack_public_path__ + "static/media/advantage-logo.b39e9d75.png";